import { Chart } from "react-google-charts";
import { useCotas } from "../hooks/useBuscarCotas";

interface CotasUsuariosDados {
  id: number;
  CotaTable: {
    AptoTable: {
      EmpreendimentoTable: {
        id: number;
        nome: string;
        origem: number;
      };
    };
  };
}

interface CotasTransformadas {
  id: number;
  origem: number;
}

export default function GraficoPizzaCotas() {
  // Busca os dados das cotas
  const { cotas } = useCotas();

  // Converte os dados para o formato esperado
  const transformarDados = (
    data: CotasUsuariosDados[]
  ): CotasTransformadas[] => {
    return data.map((item) => ({
      id: item.id,
      origem: item.CotaTable?.AptoTable?.EmpreendimentoTable?.origem || 0,
    }));
  };

  const dadosTransformados = transformarDados(cotas);

  // Agrupa por origem 0 ou diferente de 0
  const agruparPorOrigem = (data: CotasTransformadas[]): [string, number][] => {
    let origemZero = 0;
    let origemNaoZero = 0;

    data.forEach(({ origem }) => {
      if (origem === 0) {
        origemZero++;
      } else {
        origemNaoZero++;
      }
    });

    return [
      ["Origem 0", origemZero],
      ["Origem ≠ 0", origemNaoZero],
    ];
  };

  // Dados agrupados no formato esperado
  const dadosAgrupados: [string, number][] =
    agruparPorOrigem(dadosTransformados);

  // Formato do gráfico
  const data: (string | number)[][] = [
    ["Categoria", "Quantidade"],
    ...dadosAgrupados,
  ];

  // Opções do gráfico
  const options = {
    title: "Cotas Usuários por Origem Empreendimento",
    pieHole: 0.4,
    is3D: false,
    colors: ["#003644", "#0099CC"], // só 2 cores
    legend: {
      position: "bottom",
    },
  };

  return (
    <div>
      <Chart
        chartType="PieChart"
        width="100%"
        height="400px"
        data={data}
        options={options}
      />
    </div>
  );
}
